// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.proposal-list__icon--complete[data-v-31432ed9]{color:#009f05}`, "",{"version":3,"sources":["webpack://./src/components/AppNavigation/Proposal/ProposalList.vue"],"names":[],"mappings":"AACA,gDACC,aAAA","sourcesContent":["\n.proposal-list__icon--complete {\n\tcolor: #009f05;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
